import { useTranslation } from "react-i18next";
import { Loader2 } from "lucide-react";
import { NeuInput } from "../../components/neu/Neu";

const BOX =
  "min-h-[140px] w-full resize-none rounded-2xl bg-background p-4 text-base leading-7 shadow-neu-in focus:outline-none focus:ring-2 focus:ring-ring sm:text-sm";

// كتلة لغة واحدة: عنوان أعلى + حقلان بارزان فقط (بلا صندوق خارجي لتفادي الصناديق المتداخلة).
const Block = ({ dir, lang, label, f, setField, busy, t }) => {
  const tk = `title_${lang}`;
  const bk = `body_${lang}`;
  return (
    <div className="grid content-start gap-3" dir={dir}>
      <div className="flex items-center justify-between gap-2">
        <span className="label-xs text-sm text-primary sm:text-xs">{label}</span>
        {busy ? <Loader2 className="h-4 w-4 animate-spin text-primary" data-testid={`notify-busy-${lang}`} /> : null}
      </div>
      <NeuInput data-testid={`notify-title-${lang}`} className="text-base sm:text-sm" placeholder={t("notify.titlePh")} value={f[tk]} onChange={(e) => setField(tk, e.target.value)} />
      <textarea data-testid={`notify-body-${lang}`} className={BOX} placeholder={t("notify.bodyPh")} value={f[bk]} onChange={(e) => setField(bk, e.target.value)} />
    </div>
  );
};

export const NoticeComposer = ({ f, setField, translating }) => {
  const { t } = useTranslation();
  return (
    <div className="grid gap-6 md:grid-cols-2">
      <Block dir="rtl" lang="ar" label={t("notify.arSide")} f={f} setField={setField} busy={translating.endsWith("_ar")} t={t} />
      <Block dir="ltr" lang="en" label={t("notify.enSide")} f={f} setField={setField} busy={translating.endsWith("_en")} t={t} />
    </div>
  );
};
